module.exports = __webpack_public_path__ + "img/about-card-2.9d45705.jpg";